import React, {useState, useEffect} from 'react'
import { Link, useLocation } from 'react-router-dom'
import InputIcon from '../../../components/Form/InputIcon'
import Select from '../../../components/Form/Select'
import RecruiterCard from '../../components/Cards/RecruiterCard'
import search from "../../assets/searchIcon/search.svg"
import location from "../../assets/searchIcon/location.svg"
import category from "../../assets/searchIcon/category.svg"
import OrganisationCardSkeleton from '../../components/Skeletons/OrganisationCard'
import back11 from '../../assets/images/49eddec5-17f2-4a0c-b7ca-5ece838b0848.jpg'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCompanies } from '../../../redux/companySlice'
import SelectIcon from '../../../components/Form/SelectIcon'
import RowPagination from "../../components/Pagination"

const FindRecruiter = () => {
    const dispatch = useDispatch();    
    const  {pathname} = useLocation()
    const { companies, loading, error } = useSelector((state) => state.company);
    const [filters, setFilters] = useState({
      keyword: '',
      location: '',
      category: '',
      page: 1,
    })

      const handlePageChange = (newPage) => {
    console.log("page selected", newPage)
    setFilters((prev) => ({
      ...prev,
      page: newPage+2,
    }));
  };

    useEffect(() => {
      dispatch(fetchCompanies(
        {
      location: filters.location,
      category: filters.category,
      keyword: filters.keyword,
      page: filters.page,
      limit: 10,
    })); 
  }, [filters.page]); 

    const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFilters((prev) => ({ ...prev, [name]: value }));
    }

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [pathname])

    return (
        <div className=''>
          <div className="bg-[#b5ff8d] h-56 w-full  px-6 lg:px-20 xl:px-40 py-8" style={{ backgroundImage: `url(${back11})`, objectFit: "cover" }}>
            <div className="flex justify-between mb-10">
              <h5 className='font-semibold text-lg'>Recruteur</h5>
              <li className="flex gap-x-2 text-sm items-center">
                <ul className="text-gray-600"> <Link to="/home">Accueil</Link>  /  <Link to="/offre">Emploi</Link> / </ul>
                <ul className="font-medium">Recruteur</ul>
              </li>
            </div>
            <div className="bg-white rounded-lg shadow h-auto p-2">
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-2">
            <div className=" col-span-3 w-full grid grid-cols-2">
            <InputIcon
              name="keyword"
              placeholder="Mot clé ..."
              noBorder={true}
              value={filters.keyword}
              onChange={handleInputChange}
            />
            <InputIcon
              className="hidden xl:block"
              name="location"
              placeholder="Localisation"
              value={filters.location}
              icon={location}
              noBorder={true}
              onChange={handleInputChange}
            />
            </div>
            <div className="flex items-center gap-x-2 gap-y-2">
              <button onClick={()=>{                 
                dispatch(fetchCompanies({   
                  location: filters.location,
                  keyword: filters.keyword,
                  page: 1,
                  limit: 10,
                }))
                }} className="p-4 py-3 bg-black rounded-md text-white font-medium w-full">
                Rechercher
              </button>
            </div>
          </div>
        </div>
          </div>
          <div className="bg-white px-6 lg:px-20 xl:px-40 h-16 shadow-sm -6 py-3">
            <div className="flex justify-between items-center">
              <div className="flex gap-2 items-center"> 
              <span className="text-lg font-semibold"> {companies?.total} Résultats </span>
              </div>

              <div className="flex gap-2 items-center"> 
              <span>Par page </span>
              <Select name="limit" className="w-40" options={["10", "15","30"]} mb='0' onChange={(e)=>setFilters({...filters, limit: e.target.value})}/> 
              
              {/* <LayoutSwitcher setListStyle={setListStyle} listStyle={listStyle} /> */}
              </div>         
            </div>
          </div>  

          <div className="flex-1 p-responsive mt-10">
            <div className="flex gap-x-6">

          <div className="w-full">
            <div className='grid grid-cols-1 lg:grid-cols-2  gap-6'>
              {
              loading ?
              Array.from({ length: 6 }).map((_, index) => (
                <OrganisationCardSkeleton key={index} />
              ))
              :
              companies?.data?.map((item)=>{
                return ( 
                  <RecruiterCard key={item.id} item={item} />
                  )
                })
              }
              </div>
            </div>
        </div>

        <RowPagination
    currentPage={filters?.page || 1}
    setCurrentPage={handlePageChange}
    totalPages={companies?.last_page}
    />
    </div>
</div>
      )
}

export default FindRecruiter